export enum DRAWER_TABS {
  PATIENTS = 'patients',
  CARE_PROVIDERS = 'care-providers',
  ADMINS = 'admins',
}
